import React from 'react';
import { Img, Txt } from "Components/GenericView";
import './style.css';

export type NumberOfCareProsRequiredPropType = {
  isReadOnly: boolean | undefined;
  minusDisabled: boolean;
  plusDisabled: boolean;
  numberOfCarePros?: number;
  onClickMinus: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  onClickPlus: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
}

const NumberOfCareProsRequired = (props: NumberOfCareProsRequiredPropType) => {
  const { isReadOnly, minusDisabled, plusDisabled, numberOfCarePros, onClickMinus, onClickPlus } = props;

  const goneIfReadOnly = isReadOnly ? " gone" : "";
  return <>
    <div className="nvd-row h">
      <Img src="/carepro.png" className="nvd-icon" />
      <div className="v grow cp-details-container">
        <Txt className="nvd-text cp-details-title" mr={21}>
          CP Details
        </Txt>
        <div className="nvd-row h center">
          <Txt className="nvd-text" mr={21}>
            Number of CPs required
          </Txt>
          <input
            type="image"
            alt=""
            className={
              "td-counter" +
              goneIfReadOnly +
              (minusDisabled ? " disable" : "")
            }
            src="/dec.png"
            onClick={(e) => onClickMinus(e)}
          />
          <span className="nvd-requiredcp-text">
            {numberOfCarePros || 1}
          </span>
          <input
            type="image"
            alt=""
            className={
              "td-counter" +
              goneIfReadOnly +
              (plusDisabled
                ? " disable"
                : "")
            }
            src="/inc.png"
            onClick={(e) => onClickPlus(e)}
          />
        </div>
      </div>
    </div>
  </>;
}

export default NumberOfCareProsRequired;